import { DropDownItem } from '@mth/core/components/shared/DropDown/types'
import { ADMIN_INTENT_TO_RE_ENROLL_OPTIONS } from '@mth/enums'

export const ADMIN_INTENT_TO_RE_ENROLL_ITEMS: DropDownItem[] = [
  { label: 'Disabled', value: ADMIN_INTENT_TO_RE_ENROLL_OPTIONS.DISABLED },
  { label: 'Unlock Enrollment Packet', value: ADMIN_INTENT_TO_RE_ENROLL_OPTIONS.UNLOCK_ENROLLMENT_PACKET },
]
